import { render, staticRenderFns } from "./SplashBanner.vue?vue&type=template&id=67148890"
import script from "./SplashBanner.vue?vue&type=script&lang=js"
export * from "./SplashBanner.vue?vue&type=script&lang=js"
import style0 from "./SplashBanner.vue?vue&type=style&index=0&id=67148890&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
